export const SaveIcon = () => {
  return (
    <img
      alt="save-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/save.svg"}
    />
  );
};

export const SearchIcon = () => {
  return (
    <img
      alt="Search-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Search.svg"}
    />
  );
};

export const undo=()=>{
  return(
    <svg width="24" height="24" viewBox="0 0 24 24"
     fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 7L4 12L9 17"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"/>
  <path d="M20 12H5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"/>
</svg>

  )
}

export const ReplaceIcon = () => {
  return (
    <img
      alt="Replace-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Replace.svg"}
    />
  );
};

export const MathEqn = () => {
  return (
    <img
      alt="Matheqn-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/MathEqn.svg"}
    />
  );
};

export const RefreshIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2" /><path d="M9 12l.01 0" /><path d="M13 12l2 0" /><path d="M9 16l.01 0" /><path d="M13 16l2 0" /></svg>
  )
}



export const BoldIcon = () => {
  return (
    <img
      alt="Bold-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/BoldIcon.svg"}
    />
  );
};

export const ItalicIcon = () => {
  return (
    <img
      alt="Italic-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/ItalicsIcon.svg"}
    />
  );
};

export const ShowChange = () => {
  return (
    <img
      alt="howchanges"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/showtrackchange.svg"}
    />
  );
};

export const HideChange = () => {
  return (
    <img
      alt="Hidechanges"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/hidetrackchange.svg"}
    />
  );
};

export const Auto = () => {
  return (
    <img
      alt="Autocorrect-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/AutoCorrectIcon.svg"}
    />
  );
};

export const Resize1 = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Resize1.svg"}
    />
  );
};

export const Resize2 = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Resize2.svg"}
    />
  );
};

export const MenuBar = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/MenuBar.svg"}
    />
  );
};

export const MenuClose = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/closeIcon.svg"}
    />
  );
};

export const ZoomOut = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/zoomOut.svg"}
    />
  );
};

export const ZoomIn = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/zoomIn.svg"}
    />
  );
};

export const TwoPage = () => {
  return (
    <img
      alt="twopageicon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/twoPageview.svg"}
    />
  );
};

